function transformValueToLabel(value) {
  let label = value.replace(/([a-z])([A-Z])/g, "$1 $2");
  return label.charAt(0).toUpperCase() + label.slice(1);
}

export const parseToFloat = value =>
  parseFloat(value.toString().replace(/[^0-9.]/g, ""));

export const CURRENCY_FORMATER = new Intl.NumberFormat({
  style: "currency",
  currency: "JMD"
});

export const currencyFormat = value => {
  return CURRENCY_FORMATER.format(parseToFloat(value).toFixed(2));
};

export const dateToAWSDate = date => {
  let day = date.getDate();
  if (day < 10) day = "0" + day;
  let month = date.getMonth() + 1;
  if (month < 10) month = "0" + month;
  return `${date.getFullYear()}-${month}-${day}`;
};

export const awsDateToDate = awsDate => {
  let date = new Date();
  const dateArray = awsDate.split("-");
  date.setFullYear(dateArray[0]);
  date.setMonth(parseInt(dateArray[1]) - 1);
  date.setDate(dateArray[2]);
  return date;
};

export const autoCompleteStringFilter = (item, searchText, itemText) => {
  return itemText.toUpperCase().includes(searchText.toString().toUpperCase());
};

export default { transformValueToLabel };
